/**
 * PetyArty Customer Account Logic
 */

window.addEventListener('DOMContentLoaded', () => {
  initLoginToggle();
  initAddressForms();
});

// 1. 登录页：切换 "登录" 和 "忘记密码"
function initLoginToggle() {
  const loginForm = document.getElementById('login-form-container');
  const recoverForm = document.getElementById('recover-form-container');
  const showRecoverBtn = document.getElementById('forgort-password-link');
  const hideRecoverBtn = document.getElementById('back-to-login-link');

  if (showRecoverBtn && loginForm && recoverForm) {
    showRecoverBtn.addEventListener('click', (e) => {
      e.preventDefault();
      loginForm.classList.add('hidden');
      recoverForm.classList.remove('hidden');
    });
  }

  if (hideRecoverBtn && loginForm && recoverForm) {
    hideRecoverBtn.addEventListener('click', (e) => {
      e.preventDefault();
      loginForm.classList.remove('hidden');
      recoverForm.classList.add('hidden');
    });
  }

  // 如果 URL 中包含 #recover，直接显示找回密码
  if (window.location.hash === '#recover') {
    if(showRecoverBtn) showRecoverBtn.click();
  }
}

// 2. 地址页：切换 "新增/编辑" 表单
function initAddressForms() {
  const addressContainer = document.getElementById('main-addresses');
  if (!addressContainer) return;

  // toggle new address form
  const addNewBtn = document.getElementById('add-new-address-btn');
  const newAddressForm = document.getElementById('AddAddress');
  const cancelNewBtn = document.getElementById('cancel-new-address');

  if (addNewBtn) {
    addNewBtn.addEventListener('click', () => {
      newAddressForm.classList.toggle('hidden');
      addNewBtn.setAttribute('aria-expanded', newAddressForm.classList.contains('hidden') ? 'false' : 'true');
    });
  }
  
  if(cancelNewBtn) {
      cancelNewBtn.addEventListener('click', () => {
          newAddressForm.classList.add('hidden');
      });
  }

  // toggle edit forms
  document.querySelectorAll('.edit-address-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const id = e.currentTarget.dataset.addressId;
      const form = document.getElementById(`EditAddress_${id}`);
      if (form) form.classList.toggle('hidden');
    });
  });

  document.querySelectorAll('.cancel-edit-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const id = e.currentTarget.dataset.addressId;
        const form = document.getElementById(`EditAddress_${id}`);
        if (form) form.classList.add('hidden');
      });
  });

  // Handle Delete
  document.querySelectorAll('.delete-address-btn').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (confirm('Are you sure you want to delete this address?')) {
        const target = e.currentTarget.dataset.target;
        const form = document.querySelector(target);
        if (form) form.submit();
      }
    });
  });
}